import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "c-co-button" }
const _hoisted_2 = {
  key: 0,
  class: "prepend__icon"
}
const _hoisted_3 = {
  key: 1,
  class: "body__loading"
}
const _hoisted_4 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  preserveAspectRatio: "xMidYMid",
  width: "20",
  height: "20",
  style: {"shape-rendering":"auto","display":"block"}
}
const _hoisted_5 = {
  key: 2,
  class: "body__text"
}
const _hoisted_6 = {
  key: 4,
  class: "append__icon"
}

import {Component} from "vue";
import {ICommonButtonEmits, ICommonButtonProps} from "@/types/main";
import CommonInput from "@/components/common/CommonInput.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonButton',
  props: {
    position: { default: "horizontal" },
    type: { default: "primary" },
    prepend: { type: Boolean },
    prependIcon: {},
    append: { type: Boolean },
    appendIcon: {},
    label: { default: "Button" },
    isDisabled: { type: Boolean },
    loading: { type: Boolean, default: false }
  },
  emits: ["clicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const clickButton = () => {
  emit("clicked");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["body", [__props.type, __props.isDisabled ? 'disabled' : '', __props.loading ? 'loading' : '']]),
      onClick: clickButton
    }, [
      (__props.prepend && __props.prependIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.prependIcon), { size: 20 }))
          ]))
        : _createCommentVNode("", true),
      (__props.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[0] || (_cache[0] = [
              _createStaticVNode("<g data-idx=\"1\" data-v-18017b7c><g transform=\"matrix(1,0,0,1,0,0)\" data-idx=\"2\" data-v-18017b7c><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" data-idx=\"3\" opacity=\"0.225001\" data-v-18017b7c></rect></g><g transform=\"matrix(0.7071067811865476,0.7071067811865476,-0.7071067811865476,0.7071067811865476,50,-20.710678118654755)\" data-idx=\"5\" data-v-18017b7c><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" data-idx=\"6\" opacity=\"0.350001\" data-v-18017b7c></rect></g><g transform=\"matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,100,0)\" data-idx=\"8\" data-v-18017b7c><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" data-idx=\"9\" opacity=\"0.475001\" data-v-18017b7c></rect></g><g transform=\"matrix(-0.7071067811865475,0.7071067811865476,-0.7071067811865476,-0.7071067811865475,120.71067811865476,49.99999999999999)\" data-idx=\"11\" data-v-18017b7c><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" data-idx=\"12\" opacity=\"0.600001\" data-v-18017b7c></rect></g><g transform=\"matrix(-1,1.2246467991473532e-16,-1.2246467991473532e-16,-1,100,100)\" data-idx=\"14\" data-v-18017b7c><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" data-idx=\"15\" opacity=\"0.725001\" data-v-18017b7c></rect></g><g transform=\"matrix(-0.7071067811865477,-0.7071067811865475,0.7071067811865475,-0.7071067811865477,50.000000000000014,120.71067811865476)\" data-idx=\"17\" data-v-18017b7c><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" data-idx=\"18\" opacity=\"0.850001\" data-v-18017b7c></rect></g><g transform=\"matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,7.105427357601002e-15,100)\" data-idx=\"20\" data-v-18017b7c><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" data-idx=\"21\" opacity=\"0.975001\" data-v-18017b7c></rect></g><g transform=\"matrix(0.7071067811865474,-0.7071067811865477,0.7071067811865477,0.7071067811865474,-20.710678118654755,50.000000000000014)\" data-idx=\"23\" data-v-18017b7c><rect fill=\"#ffffff\" height=\"13\" width=\"7\" ry=\"6.5\" rx=\"3.5\" y=\"17.5\" x=\"46.5\" data-idx=\"24\" opacity=\"0.100001\" data-v-18017b7c></rect></g><g data-idx=\"26\" data-v-18017b7c></g></g>", 1)
            ]))]))
          ]))
        : _createCommentVNode("", true),
      (__props.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(__props.label), 1))
        : _renderSlot(_ctx.$slots, "default", { key: 3 }),
      (__props.append && __props.appendIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.appendIcon), { size: 20 }))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})